module.exports = __webpack_public_path__ + "static/media/user.3871373e.svg";